import { Icon, Tooltip } from "@chakra-ui/react";
import React from "react";
import { MdVerified } from "react-icons/md";

// Kolor odznaki weryfikacji — wyraźny, rozpoznawalny „verified" (mObywatel).
const VERIFIED_COLOR = "#1d9bf0";

// Odznaka „konto zweryfikowane" — używana wszędzie przy nazwisku/awatarze. Znaczący, ząbkowany kształt.
export const VerifiedBadge: React.FC<{ size?: string; ml?: string }> = ({ size = "16px", ml = "0" }) => (
  <Tooltip label="Konto zweryfikowane (mObywatel)" hasArrow openDelay={250}>
    <span style={{ display: "inline-flex", marginLeft: ml }}>
      <Icon as={MdVerified} color={VERIFIED_COLOR} boxSize={size} aria-label="Zweryfikowany" />
    </span>
  </Tooltip>
);

// Wariant nakładany na róg awatara (bottom-right) — w białej obwódce, żeby się odcinał.
export const AvatarVerifiedTick: React.FC<{ size?: string }> = ({ size = "18px" }) => (
  <span
    style={{
      position: "absolute",
      bottom: "-3px",
      right: "-3px",
      background: "white",
      borderRadius: "50%",
      display: "inline-flex",
      padding: "1px",
      boxShadow: "0 0 0 1.5px white"
    }}
  >
    <Icon as={MdVerified} color={VERIFIED_COLOR} boxSize={size} aria-label="Zweryfikowany" />
  </span>
);

export default VerifiedBadge;
